"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _gridContainer = require("../grid-container");

var _visuallyHidden = _interopRequireDefault(require("../visually-hidden"));

var _mobileNav = _interopRequireDefault(require("./mobile-nav"));

var _desktopNav = _interopRequireDefault(require("./desktop-nav"));

var _routes = _interopRequireDefault(require("./shared/routes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Header = (0, _styledComponents["default"])(_gridContainer.GridContainer).withConfig({
  displayName: "top-nav__Header",
  componentId: "sc-1uwslzv-0"
})(["background-color:", ";position:sticky;top:0;height:56px;z-index:1;box-shadow:", ";@media screen and (-webkit-min-device-pixel-ratio:0) and (min-resolution:.001dpcm){top:-1px;}"], function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.effects.boxShadow.cards;
}); // Note, the last @media is because of a Chrome bug with high dpi devices (retina)
// Link to issue on Google: https://bit.ly/35gkOhY
// Link to where I got the chrome detect: https://www.browserstack.com/guide/create-browser-specific-css#toc2

var TopNav = function TopNav(_ref) {
  var _ref$routes = _ref.routes,
      routes = _ref$routes === void 0 ? _routes["default"] : _ref$routes,
      props = _objectWithoutProperties(_ref, ["routes"]);

  return /*#__PURE__*/_react["default"].createElement(Header, {
    variant: "full"
  }, /*#__PURE__*/_react["default"].createElement(_visuallyHidden["default"], null, /*#__PURE__*/_react["default"].createElement("nav", {
    "aria-label": "Customer Service"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "/about-us"
  }, "About Us"), /*#__PURE__*/_react["default"].createElement("a", {
    href: "/https://assets.ctfassets.net/ljtyf78xujn2/1HCXSo66lWoLcQTlX4clK9/dc90b273b64e489029124282b19dc2af/Glowforge_Manual_2.9.pdf"
  }, "User Manual"), /*#__PURE__*/_react["default"].createElement("a", {
    href: "/support"
  }, "Support"))), /*#__PURE__*/_react["default"].createElement(_mobileNav["default"], _extends({
    routes: routes
  }, props)), /*#__PURE__*/_react["default"].createElement(_desktopNav["default"], _extends({
    routes: routes
  }, props)));
};

TopNav.propTypes = {
  routes: _propTypes["default"].shape({
    primaryRoutes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      text: _propTypes["default"].string,
      url: _propTypes["default"].string,
      local: _propTypes["default"].bool,
      logoLink: _propTypes["default"].bool
    })),
    userRoutes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      text: _propTypes["default"].string,
      url: _propTypes["default"].string,
      local: _propTypes["default"].bool
    }))
  }),
  user: _propTypes["default"].shape({
    first_name: _propTypes["default"].string,
    last_name: _propTypes["default"].string
  }),
  userFetchState: _propTypes["default"].oneOf(['pending', 'error', 'complete']),
  buttonSection: _propTypes["default"].node,
  activeLink: _propTypes["default"].string
};
var _default = TopNav;
exports["default"] = _default;